import React, { useEffect, useState } from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import { Accordion, Col, Row } from 'react-bootstrap';
import ToggleButton from 'react-toggle-button';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getActionTaken, getActionTakenForAE, getAllCausalities, getAllOutComes, getSAdvEvents, getStudyAeDetails, getStudyTitles, getSubjectList } from '../../../Redux/actions/actions';
import { EVENT_CLASSIFICATION_AESI, EVENT_CLASSIFICATION_GRADE_CTCAE, EVENT_CLASSIFICATION_LEVEL_BRIGHTON, EVENT_CLASSIFICATION_OTHER, EVENT_STATUS_IN_PROGRESS, EVENT_STATUS_REVIEWED, EVENT_STATUS_SENT_BACK_FOR_REVIEW, EVENT_STATUS_WAITING_FOR_REVIEW, TOGGLE_NO, TOGGLE_YES, base_url } from '../../../utilities';
import BrightonCase from '../SubjectFlow/BrightonCase';
import GradeCase from '../SubjectFlow/GradeCase';
import PopUpModal from '../../ReusableComp/PopUpModal';
import InputComponent from '../../ReusableComp/InputComponent';
import moment from 'moment';
import axios from '../../../axios-interceptor';
import Loader from '../../ReusableComp/Loader'; // Import the Loader component
import { toast } from 'react-toastify';
import Select from "react-select";

const AddNewDoseToSubject = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

const saEvents = useSelector((state) => state.getSAEvents);
const studyAeDtls = useSelector((state) => state.getStudyAeDtls);
const outComes = useSelector((state) => state.getOutComes);
const actnTakenOpts = useSelector((state) => state.actionTaken);
const causalities = useSelector((state) => state.getCausalities);
const subjNumber = useSelector((state) => state.getSubjNum);
const studyTitles = useSelector((state) => state.getStdyTitls);
const subjectList = useSelector((state) => state.currentDose);  
const actionTakenforAe = useSelector((state) => state.actionTakenforAe);
    const [studyDropdwn, setStudyDropdwn] = useState(false)
    const [regStep, setRegStep] = useState(1);
    const [aEClassification, setAEClassification] = useState("");
    const [timeOfResolution, setTimeOfResolution] = useState(null)
    const [doseOptions, setDoseOptions] = useState(null);
    const [statusOptions, setStatusOptions] = useState(null);
    const [subjData, setSubjData] = useState({}); 
    const [subjectId, setSubjectId] = useState();
    const [file, setFile] = useState([]);
    const [loading, setLoading] = useState(false);
    const [flag, setFlag] = useState(true);
    const [newFlag,SetNewFlag]=useState("");
    const [selectedAction, setSelectedAction] = useState()

useEffect(() => {
    if(window.location.pathname ==='/addnewdosetosubject'){
        setStudyDropdwn(true)
      } 
      dispatch(getSAdvEvents())
      dispatch(getActionTakenForAE())
      dispatch(getAllOutComes())
      dispatch(getStudyTitles(subjData.study_id ))
        dispatch(getActionTaken())
        dispatch(getAllCausalities())
}, [ dispatch, studyDropdwn, subjData.study_id])

useEffect(() => {
    // Calculate doseOptions whenever subjectList changes
    if (subjectList?.length > 0) {
        const uniqueDoses = Array.from(new Set(subjectList.map(json => json.dose))).filter(Boolean);
        const optionsList = uniqueDoses.map((dose) => ({
            label: dose,
            value: dose
        }));
        setDoseOptions(optionsList);

        const uniqueStatus = Array.from(new Set(subjectList?.map(json => json.status))).filter(Boolean);
        const optionsStatusList = uniqueStatus?.map((val) => ({
            label: val,
            value: val
        }));
        setStatusOptions(optionsStatusList);
    }
}, [subjectList]);



const registrationSteps = [
    {
        stepTitle: "1. Subject Selection",
        description: "Selection of subject"
    },
    {
        stepTitle: "2. Dose Details",
        description: "Dose 1, Dose 2, etc."
    },
    {
        stepTitle: "3. Adverse Events",
        description: "Adverse Events"
    },
    {
        stepTitle: "4. Concomitant Medication",
        description: "Concurrent Medication"
    },
    {
        stepTitle: "5. Preview and Confirm",
        description: "Summary of subject registration"
    },

];
let optedStudy;
const [selectedOption, setSelectedOption] = useState('');
const [toggleSAE, setToggleSAE] = useState(false);
const [dateofOnsetSAE, setDateofOnsetSAE] = useState(null);
const [searchTerm, setSearchTerm] = useState("");
const [showPopup, setShowPopup] = useState(false);
const [btnTitle, setBtnTitle] = useState("");
const [seriousAE, setSeriousAE] = useState({});
const [eventDesc, setEventDesc] = useState()
const [radioValue, setRadioValue]= useState('')
const [radioReset, setRadioReset] =useState('')
const [inputTextNotes, setInputTextNotes] = useState('')
const [treatmentGiven, setTreatmentGiven] = useState("")
const [caseDef, setCaseDef] =useState()
const [dateOfResolution, setDateOfResolution] = useState(null);
const [valuForDisble, setValuForDisble] = useState()
const [fileNames, setFileNames] = useState([]);
const [open, setOpen] = React.useState(false);
const [concomitantRadio, setConcomitantRadio] = useState('no')
const [today, setToday] = useState('');
const [actionAdverse,setActionAdverse]=useState("Select");
const [choosenOption, setChoosenOption] = useState('Select');
const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');
const [btnDisable, setBtnDisable] = useState(false)
const getPiStudiesList = useSelector((state) => state.piStudyList);

 

useEffect(() => {
  if(window.location.pathname ==='/addnewdosetosubject' && regStep>1){
    setBtnDisable(true)
  }else{
      setBtnDisable(false)
  }  
  const currentDate = new Date();
  const formattedDate = currentDate.toDateString();
  setToday(formattedDate);
  }, [today, regStep, btnTitle]);
const [medicationDetails, setMedicationDetails] = useState([
    {
      "medication": "",
      "medication_manufacturer": "",
      "medication_batch_number": "",
      "medication_route_site": "",
      "medication_dosage":"",
      "medication_frequency": "",
      "current_idx":1
    },
  ]);
const [concomitantMedication, setConcomitantMedication]= useState(false)

const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const newArray = [...medicationDetails];
    newArray[index][name] = value;
    setMedicationDetails(newArray);
    if(concomitantRadio =='no'){
        setMedicationDetails([]);
    }
  };
  const handleAddFields = () => {
    setMedicationDetails([...medicationDetails, 
        {
            "medication": "",
            "medication_manufacturer": "",
            "medication_batch_number": "",
            "medication_route_site": "",
            "medication_dosage":"",
            "medication_frequency": "",
            "current_idx":currentIndex+1
        },]);
        setCurrentIndex(currentIndex + 1);
  };
  const [currentIndex, setCurrentIndex] = useState(1);

  const handleDeleteFields = (index) => {
    let updatedData = [...medicationDetails]
    updatedData?.map((elemObj,i)=>{
      if(elemObj.current_idx==index.current_idx){
        updatedData.splice(i,1)
      }
    })

    
    setMedicationDetails(updatedData)
  }
const handleStepChange = (val) => {
    if(val > 0 && regStep < registrationSteps.length + 1){
        let shift = regStep + val
        setRegStep(shift);
    }
    if(val < 0 && regStep > 1){
        let shift = regStep + val
        setRegStep(shift);
    }
    
}
function handleExitSubRej() {
  navigate('/pisubjectslist')
}
const handleFileUpload = (event) => {
  const maxIndividualFileSize = 10 * 1024 * 1024; // 10MB in bytes
  const maxCombinedFileSize = 30 * 1024 * 1024; // 30MB in bytes
  const maxFiles = 3; // Maximum allowed files

  const files = Array.from(event.target.files);
  const totalSize = files.reduce((acc, file) => acc + file.size, 0);
 
  if (files.length > maxFiles) {
    toast.error(`You can upload a maximum of ${maxFiles} files`, {
      toastId: 9,
    });
  } else if (files.every((file) => file.size <= maxIndividualFileSize) && totalSize <= maxCombinedFileSize) {
    const newFileNames = files.map((file) => file.name);
    const newFile = files;
    setFile((prevFile) => [...prevFile, ...newFile]);
    setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
  } else {
    if (!files.every((file) => file.size <= maxIndividualFileSize)) {
      toast.error("File size should be less than 10 MB", {
        toastId: 7,
      });
    }
    
  }
};
const handleDrop = (event) => {
  event.preventDefault(); // Prevent automatic preview
  if (event.dataTransfer.items) {
    const files1 = event.dataTransfer.items;
    const fileList = Array.from(files1).map((item) => item.getAsFile());
    const maxIndividualFileSize = 10 * 1024 * 1024; // 10MB in bytes
    const maxCombinedFileSize = 30 * 1024 * 1024; // 30MB in bytes
    const maxFiles = 3; // Maximum allowed files
    const files = Array.from(fileList);
    const totalSize = files.reduce((acc, file) => acc + file.size, 0);
    if(file.length<3){
    if (files.length > maxFiles) {
      toast.error(`You can upload a maximum of ${maxFiles} files`, {
        toastId: 9,
      });
    } else if (
      files.every((file) => file.size <= maxIndividualFileSize) &&
      totalSize <= maxCombinedFileSize
    ) {
      const newFileNames = files.map((file) => file.name);
      const newFile = files;
      setFile((prevFile) => [...prevFile, ...newFile]);
      setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
    } else {
      if (!files.every((file) => file.size <= maxIndividualFileSize)) {
        toast.error("File size should be less than 10 MB", {
          toastId: 7,
        });
      }
    }
  }
    else{
      toast.error(`You can upload a maximum of ${maxFiles} files`, {
        toastId: 9,
      });
    }
}
};
  const handleRemoveFile = (index) => {
    setFileNames((prevFileNames) => {
      const newFileNames = [...prevFileNames];
      newFileNames.splice(index, 1);
      return newFileNames;
    });
    setFile((prevFileNames) => {
      const newFileNames = [...prevFileNames];
      newFileNames.splice(index, 1);
      return newFileNames;
    });
  };
const handleDragOver = (event) => {
event.preventDefault();
};
const handleTimeOfResolutionChange = (e) => {
    setTimeOfResolution(e.target.value);
    };
function getEventDescId(val){
    if(val){
      setEventDesc(val)
      setValuForDisble(val)
      }
      
  }
const handleDateOfResolutionChange = (e) => {
    setDateOfResolution(e.target.value);
    };
const handleAesiInputText=(e)=>{
    let value = e.target.value;
        if(caseDef === EVENT_CLASSIFICATION_AESI){
        const updatedObject = {
          ...eventDesc,
          event_description_id: studyAeDtls[0]?.other_case?.study_aesi_description_id
        };
        setEventDesc(updatedObject)
      }
  
         if(value!==''){
          setInputTextNotes(value)
         }else{setInputTextNotes('')}
      }
      const handleTreatment=(e)=>{
        let value = e.target.value;
         if(value!==''){ setTreatmentGiven(value)}
         else{setTreatmentGiven('')}
         
      }
const handleReset=()=>{
    setRadioReset('')
  }
function handleRadioBtn(val){
    setRadioValue(val)
  }
function handleSearch(e) {
    setSearchTerm(e.target.value);
}
function handleDropDown() {
    setShowPopup(!showPopup)
    setSearchTerm('');

}
const handleDateOfOnsetSae = (e) => {
    setDateofOnsetSAE(e.target.value);
};
function handleOption(e) {
    setBtnTitle(e.serious_adverse_event_name)
    setSearchTerm(e.serious_adverse_event_name);
    setSeriousAE({
      label: e.serious_adverse_event_name,
      value: e.serious_adverse_event_id,
    })
    setTimeout(() => {
      setShowPopup(false)
    }, 100);
  }
const handleSaeToggle=()=>{
    setToggleSAE(!toggleSAE) 
    setDateofOnsetSAE('')
    setSeriousAE('')
    setSearchTerm('')
    setBtnTitle('Select Adverse Criteria')
  }
  const [doseDetailsPg, setDoseDetailsPg] = useState(
    {
      date_of_administration: moment(new Date().toDateString()).format("YYYY-MM-DD"),
      time_of_administration:null,
      batch_number:null,
      expiry_date:null,
      date_of_manufacture:null,
      
    }
    )
function handleDoseDetails(e){
const { name, value } = e.target;
setDoseDetailsPg((prev => ({...prev,
    [name]:value,
})))
fifthInputs.date_of_onset =""
}

 let isDoseDetails = Object.values(doseDetailsPg).every(value => value !== null)

const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    //setConcomitantMedication(e.target.value)
  };


const [fifthInputs, setFifthInputs] = useState({
    date_of_onset:'',
    time_of_onset:'',
    causality_id:'',
    outcome_id:'',
    action_taken_id:'',

        })

        let medicationDtlsBtn = medicationDetails.some(detail => {
            let indx=detail.current_idx;
            delete detail.current_idx;
            let x= !Object.values(detail).every(value => value.length)
            detail.current_idx=indx;
            return x
          })
        // const [dose, setDose] = useState('');
        const dosesArray = Array.from({ length: optedStudy?.number_of_doses}, (idx, i) => i + 1);

        const [aeLabel, setAeLabel]  = useState('')

 const handleAEClassification=(i)=>{
            if(i.target.value !=='Select Adverse Event')
            {
          const case_def = Number(i.target.options[i.target.selectedIndex].getAttribute('case_def'))
          const optionValue = (i.target.options[i.target.selectedIndex].getAttribute('value'))
          const optionLabel=(i.target.options[i.target.selectedIndex].getAttribute('label'))
            setAeLabel(optionLabel)
            setEventDesc('')
            setRadioValue('')
            setRadioReset('reset')
            setInputTextNotes('')
            setTreatmentGiven('')
            setTimeOfResolution('')
            setDateOfResolution('')
            setFifthInputs((prev) => {
              const blankState = {};
              for (const key in prev) {
                blankState[key] = "";
              }
              return blankState;
            });
          
            
                  setCaseDef(case_def)
                  setAEClassification(optionValue)
          
                  if(case_def !== EVENT_CLASSIFICATION_OTHER)
                  {
                    dispatch(getStudyAeDetails(i))
                  }
                  
                if(case_def=== EVENT_CLASSIFICATION_OTHER  ){
                  setEventDesc({study_aebank_id:optionValue, event_description_id:null})
                }
                if(case_def=== EVENT_CLASSIFICATION_AESI  ){
                  setEventDesc({study_aebank_id:optionValue})
                }
              }
              else if(i.target.value ==='Select Adverse Criteria'){
                setAEClassification('')
          
              }
              }

              const handleConcomitantRadio=(e)=>{
                setConcomitantRadio(e.target.value)
                if(e.target.value =='no'){
                    setConcomitantRadio(e.target.value)
                 medicationDetails.forEach(obj => {
                        for (const key in obj) {
                          obj[key] ='';  
                        }
                      });
                      setMedicationDetails(medicationDetails)
            
                }
            }              
        
        const handleAeOptions = (e) => {
          const { name, value } = e.target;
          const selectedValue = e.target.value;
            let flagValue = true;
            if (name === "action_taken_for_ae") {
              setSelectedAction(e.target.options[e.target.selectedIndex].innerHTML)
              if (selectedValue === "Select") {
                flagValue = true;
                SetNewFlag("None");
              } else {
                for (var i = 0; i < actionTakenforAe.length; i++) {
                  var currentObject = actionTakenforAe[i];
                  if (currentObject.action_taken_for_adverse_event_id === value) {
                    setActionAdverse(currentObject.action_taken_for_adverse_event_name);
                    if (currentObject.action_taken_for_adverse_event_name === "None") {
                      flagValue = true;
                      SetNewFlag(currentObject.action_taken_for_adverse_event_name)
                      setStartDate("")
                      setEndDate("")
                    } else {
                      SetNewFlag(currentObject.action_taken_for_adverse_event_name)
                      flagValue = false;
                      setStartDate("")
                      setEndDate("")
                    }
                  }
                }
              }
            // } else if (
            //   name === "causality_id" ||
            //   name === "outcome_id" ||
            //   name === "action_taken_id"
            // ) {
            //   // Check for specific values of newFlag
            //   if (newFlag === "Surgical Treatment" || newFlag === "Medical Treatment") {
            //     flagValue = false;
            //   } else {
            //     flagValue = true;
            //   }
            }
            
            setChoosenOption(selectedValue);
          if (
            name === "causality_id" ||
            name === "outcome_id" ||
            name === "action_taken_id" ||
            name === "action_taken_for_ae"
          ) {
            if(flag===false){
              flagValue=false;
            }
            if (value !== "Select") {
              setFifthInputs((prev) => ({
                ...prev,
                [name]: value,
              }));
            } else {
              setFifthInputs((prev) => ({
                ...prev,
                [name]: "",
              }));
            }
          }else {
            if(flag===false){
              flagValue=false
            } 
            
            setFifthInputs((prev) => ({
              ...prev,
              [name]: value,
            }));
            // if (newFlag === "Surgical Treatment" || newFlag === "Medical Treatment") {
            //   flagValue = false;
            // } else {
            //   flagValue = true;
            // }
          }
          // Set the flag value
          setFlag(flagValue);

          if(name==="date_of_onset"){
            setDateOfResolution('')
            setTimeOfResolution('')
            setStartDate('')
            setEndDate('')
          }
        };

function clearField(){
  setSelectedSubject(null)
  setSubjData({})
}

        const [selectedSubject, setSelectedSubject] = useState(null);

        const handleSelectedSubj1 = selectedOption => {
          setSelectedSubject(selectedOption);
        
          if (selectedOption.value !== 'Select') {
            setSubjectId(selectedOption.value);
        
            const selctdSubj = subjectList?.find(i => i.subject_id === selectedOption.value);
            setSubjData(selctdSubj);
            evaluateDuration(selctdSubj)
          } else {
            setSubjData({});
            setSubjectId('');
          }
        };
        const filteredOptions = subjectList?.filter(
          sub => sub.number_of_doses !== sub.current_dose?.dose
        );
        const options = filteredOptions?.map(sub => ({
          value: sub.subject_id,
          label: `${sub.first_name} ${sub.last_name} - ${sub.subject_code}`,
        }));


 const fifthDisable = Object.keys(fifthInputs)
 .map((key) => fifthInputs[key])
 .every((value) => value !== '');

 function handleSelectedSubj(e) {
   const subjId = e.target.value;

   if(subjId !=='Select'){setSubjectId(subjId)
  
   const selctdSubj = subjectList&&subjectList.find((i) => i.subject_id === subjId);
   setSubjData(selctdSubj)}
   else{
    setSubjData({})
    setSubjectId('')
   }
 }
 const emptyObj = Object.keys(subjData).length === 0

 const handleClosePopup = () => {
    setOpen(false);
    navigate('/pisubjectslist')
    setTimeout(() => {
      window.location.reload();
      
    }, 100);
  };
  const handleReviewActions = () => {
    setOpen(false);
    navigate('/pisubjectslist')
    setTimeout(() => {
      window.location.reload();
      
    }, 100);
  }
  const [timeError, setTimeError] = useState("");
  const [showTimeError, setShowTimeError] = useState(false)

  function validateTimeOfResolution(event) {
    const inputTime = event.target.value;
    const timeOfOnset = fifthInputs.time_of_onset;
  
    if (timeOfOnset) {
      // Convert input times to minutes for comparison
      const inputTimeMinutes = timeStringToMinutes(inputTime);
      const timeOfOnsetMinutes = timeStringToMinutes(timeOfOnset);
  
      if (inputTimeMinutes < timeOfOnsetMinutes) {
        const val = "Select time after "+fifthInputs.time_of_onset
        setTimeError(val)
        setShowTimeError(true)
        // If the input time is before the time of onset, clear the input
        event.target.value = '';
      }
      else{
        setTimeError("val")
        setShowTimeError(false)
      }
    }
  }
  
  
  function timeStringToMinutes(timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  }
 
  const [isbtnDisabled, setIsbtnDisabled] = useState(false);
  const handleAddDosetoSubj =()=>{
    let doseObj = {
      "subject_id":subjData.subject_id,
      "pi_id":localStorage.pi_id,
      "dose": subjData.current_dose.dose+1,
      "route_of_administration": subjData.dose_of_administration,
      "anatomical_site_administration": subjData.anatomical_site_administration,
      "date_of_administration": doseDetailsPg.date_of_administration,
      "time_of_administration": doseDetailsPg.time_of_administration,
      "date_of_manufacture": doseDetailsPg.date_of_manufacture,
      "expiry_date": doseDetailsPg.expiry_date,
      "batch_number": doseDetailsPg.batch_number,
      "is_ae_with_in_30mins": selectedOption === 'yes' ? TOGGLE_YES : TOGGLE_NO || null,
      "date_of_onset": fifthInputs.date_of_onset === '' ? null : fifthInputs.date_of_onset,
      "time_of_onset": fifthInputs.time_of_onset === '' ? null : fifthInputs.time_of_onset,
      "date_of_resolution": dateOfResolution === '' ? null : dateOfResolution || null,
      "time_of_resolution": timeOfResolution === '' ? null : timeOfResolution,
      "study_aebank_id": eventDesc?.study_aebank_id || null,
      "study_case_definition": caseDef === '' ? null : caseDef,
      "study_id": subjData.study_id,
      "event_description_id": eventDesc?.event_description_id || null,
      "input_notes_aesi_others": inputTextNotes === '' ? null : inputTextNotes || null,
      "action_taken_id": fifthInputs.action_taken_id || null,
       start_date_of_treatment:startDate==="" ? null : startDate,
       end_date_of_treatment:endDate==="" ? null : endDate,
      "causality_id": fifthInputs.causality_id,
      "outcome_id": fifthInputs.outcome_id,
      "any_treatment_given": treatmentGiven === '' ? null : treatmentGiven,
      "is_serious_adverse_event": toggleSAE ? TOGGLE_YES : TOGGLE_NO,
      "serious_adverse_event_id": seriousAE?.value || null,
      "is_concomitant_medication":concomitantRadio === 'yes' ? TOGGLE_YES : TOGGLE_NO,
      "concomitant_medication": medicationDetails,
      "created_by": localStorage.login_user_name  
    }
    
    // Create a new FormData instance
    const formData = new FormData();
    // Append each property to the FormData
    for (const key in doseObj) {
      if(doseObj[key]!== null){
        if(key == 'concomitant_medication')
          formData.append(key, JSON.stringify(doseObj[key]));
        else  
          formData.append(key, doseObj[key]);
      }
        
    }
    for (let i = 0; i < file.length; i++) {
      formData.append('files', file[i]);
    }
    setIsbtnDisabled(true)
    setLoading(true);
      axios
      .post(base_url + 
        "subjects/add_new_dose_for_existing_subject", formData,{
           headers: {
          'Content-Type': 'multipart/form-data'
      }})
    .then((res) => {
      setIsbtnDisabled(false)
      setLoading(false);
      if(res.data.message ==='New dose added to existing subject'){
      setOpen(true) }
    else{
        toast.error(res.data.message, {
          toastId: 1
        }
        
        )

    }

    }) .catch((error) => {
      setLoading(false);
      setIsbtnDisabled(false)
         console.log(error)
      });
    
 
  }

function handleClose(){
  navigate('/pisubjectslist')
}
const maxDate = new Date().toISOString().split('T')[0];
const minDate = fifthInputs.date_of_onset && new Date(fifthInputs.date_of_onset).toISOString().split('T')[0];
const JustBtwn = "d-flex justify-content-between";
const next = "orange_btn px-4 orange_btn_mbl";

const handleStartDateChange = (e) => {
  setStartDate(e.target.value);
  setEndDate('')
};

const handleEndDateChange = (e) => {
  const selectedEndDate = e.target.value;
  if (selectedEndDate < startDate) {
    return;
  }
  setEndDate(selectedEndDate);
};
const [validDuration, setValidDuration] = useState(true)
const [nextDate, setNextDate] = useState("")
const evaluateDuration = (selctdSubj) => {
  const nextDoseDate = moment(selctdSubj?.current_dose.date_of_administration)
  .add(
    getPiStudiesList?.find((item) => item.study_id === localStorage.getItem('study_id')).duration_between_doses,
    'days'
  );

    setNextDate(nextDoseDate)

    // Get today's date
    const today = moment();

    // Compare the next dose date to today's date
    const isNextDoseDateBeforeOrEqualToday = nextDoseDate.isSameOrBefore(today);

    if (isNextDoseDateBeforeOrEqualToday) {
      
      setValidDuration(true)
    } else {
      setValidDuration(false)
      
    }
}
useEffect(() => {
  const handleBeforeUnload = (event) => {
    const message = "Are you sure you want to leave? Your data may be lost.";
    event.returnValue = message; // Standard for most browsers
    return message; // For some older browsers
  };

  const startListener = () => {
    window.addEventListener('beforeunload', handleBeforeUnload);
  };

  const stopListener = () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };

  // Start listener when component mounts
  startListener();

  // Stop listener when component unmounts
  return () => {
    stopListener();
  };
}, []);

 
    return (
      <>
      <div>
         <NavigationBar
        title={"New Dose"}
        btnDisable={btnDisable}
        clearField={clearField}
      />
       {/* < PIFlowLeftNavBar /> */}
      <div className='main_body registration_steps_main'>
          <div className="row">
            <div
              className="col-lg-3 "
              style={{
                backgroundColor: "#E2E8F0",
              }}
            >

              <div className="lableSteps regstep_title">
                <span>Registration Steps</span>
              </div>

              <div className='subj_reg_mbl' style={{ maxHeight: "66vh", overflowY: "auto" }}>
                {registrationSteps.map((step, index) => {
                  return (
                    <div
                      key={index}
                      className={`${regStep === index + 1 ? "selectedTabStyl" : ""
                        }`}
                    >
                      <div
                        className={`my-div ${regStep === index + 1
                          ? "registration_steps_selected selectdMr"
                          : "registration_steps"
                          }`}
                        key={index}
                      >
                        <span>{step.stepTitle}</span>
                        <span className="registration_description">
                          {step.description}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>


            </div>
            <div className="col">
            <div className="lableContent top-stepper-main subj_reg_mbl">
              <div className="regStepsMain">
                {registrationSteps.map((item, index) => (
                  <div
                  key={index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div
                        className={`${
                          regStep >= index + 1 ? "stageSelected" : "stage"
                        }`}
                      >
                        <span>{index + 1}</span>
                      </div>
                    </div>
                    
                  </div>
                ))}
              </div>
            </div>
            {regStep === 1 &&(
                <div className='subject_reg_body addnewaembl'>
                        <div>
                              <Select
                                styles={{ width: '70%' }}
                                options={options}
                                // className="custom-select"  
                                value={selectedSubject}
                                onChange={handleSelectedSubj1}
                                className='custom_select_main'
                                placeholder="Select subject"
                              />
                              </div>
                                {validDuration ? null : <p style={{color:"red"}}>Note: The recent dose duration is not complete, you can add new dose on or after {moment(nextDate).format("DD-MM-YYYY")}</p>}
                                {!emptyObj && <div className='subj_details'>  
                                <p><b>Subject Name : </b>{subjData.first_name}{" "}{subjData.last_name}</p>
                                {/* <p><b>Subject Id : </b>{subjData.subject_code}</p> */}
                                {/* =======working here */}
                                
                                <p><b>Subject Code :</b> {subjData.subject_code}</p>
                                <p><b>Phone Number :</b> {subjData.phone_number}</p>
                                <p><b>Date of Birth:</b> {moment(subjData.date_of_birth).format("DD-MM-YYYY")}</p>
                                {/* <p><b>Age:</b> {subjData.age}</p> */}
                                <p><b>Weight:</b> {subjData.weight}</p>
                                <p><b>Gender:</b> {subjData.sex}</p>
                                <p><b>Recent Dose:</b> D{subjData.current_dose.dose}</p>
                                <p><b>No. of Doses:</b> {subjData.number_of_doses}</p>
                                <p><b>Date of administration:</b> {moment(subjData.current_dose.date_of_administration).format("DD-MM-YYYY")}</p>
                                <p><b>Time of administration:</b> {moment(subjData.current_dose.time_of_administration, "HH:mm:ss Z").format("HH:mm")}</p>
                                <p><b>Dose of Administration:</b> {subjData.dose_administration_name}</p>
                                <p><b>Anatomical site of Administration:</b> {subjData.anatomical_site_administration_name}</p>
                                {/* <p><b>Medication used in last 3 Weeks :</b> {subjData.medication_used_in_last_3weeks?subjData.medication_used_in_last_3weeks:'-'} </p> */}
                               
                                {/* <p><b>Status:</b> {
                                  subjData.status === EVENT_STATUS_IN_PROGRESS? "In progress":
                                  subjData.status === EVENT_STATUS_REVIEWED? "Reviewed":
                                  subjData.status === EVENT_STATUS_SENT_BACK_FOR_REVIEW? "Sent back for review":
                                  subjData.status === EVENT_STATUS_WAITING_FOR_REVIEW? "Waiting for review":
                                ""
                                }</p> */}
                                
                                </div>}

                </div>
            )}


            {regStep === 2 && (
              <div className="subject_reg_body">
                <div className='row d-flex gap-3 mt-0'>
                  <div className="col">
                    <label htmlFor="mrName">
                      Name of the study
                    </label>
                    <input
                      value={subjData?.study_name}
                      disabled
                      className="customInput"
                      id="firstName"
                      type="text"
                      placeholder="Enter study name"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                    //   onChange={handleStudyChange}
                    />
                  </div>

                  <div className="col">
                    <label htmlFor="dose">
                      Dose 
                    </label>
                    <input
                      name="dose"
                      type='text'
                      disabled
                      id="piStudy"
                      className="selectTag-subj subj_dose_input"
                      style={{ width: "380px" }}
                      value={`D${subjData.current_dose?.dose+1}`}
                    //   onChange={handleDoseChange}
                    />
                      
                    
                  </div>
                
                
                  <div className="col-12 col-lg col-md">
                    <label htmlFor="Rout of Administration">
                      Route of administration
                    </label>
                    {/* <select id='piStudy' className='selectTag'  style={{width:"380px"}} value={route}>
                                        <option>Oral</option>
                                    </select> */}
                    <input
                      value={subjData?.dose_administration_name}
                      className="customInput"
                      id="Rout of Administration"
                      type="text"
                      placeholder=""
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                    //   onChange={handleStudyChange}
                      disabled
                    />
                  </div>

                  <div className="col col-12 col-lg col-md">
                    <label htmlFor="lastName">
                      Anatomical site of administration
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </label>
                    {/* <select id='piStudy' className='selectTag'  style={{width:"380px"}} value={anatomical} >
                                        <option>Mouth</option>
                                    </select> */}
                    <input
                      value={subjData?.anatomical_site_administration_name}
                      className="customInput"
                      id="Anatomical"
                      type="text"
                      placeholder=""
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                    //   onChange={handleStudyChange}
                      disabled
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="mrName">
                      Date of administration
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={doseDetailsPg.date_of_administration===null? moment(today).format("YYYY-MM-DD"):doseDetailsPg.date_of_administration}
                      className="customInput"
                      id="firstName"
                      name='date_of_administration'
                      type="date"
                      placeholder="Enter here"
                      max={new Date().toISOString().slice(0, 10)}
                      min={moment(nextDate).format("YYYY-MM-DD")}
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px",cursor: "not-allowed" }}
                      onChange={handleDoseDetails}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {doseDetailsPg.date_of_administration?null:
                    <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                    }
                  </div>

                  <div className="col-12 col-lg col-md">
                    <label htmlFor="lastName">
                      Time of administration (24 hrs)
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={doseDetailsPg.time_of_administration}
                      className="customInput"
                      name='time_of_administration'
                      id="lastName"
                      type="time"
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleDoseDetails}
                    />
                    {doseDetailsPg.time_of_administration?null:
                    <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                    }
                  </div>
                 
                  <div className="col">
                    <label htmlFor="date_of_manufacture">
                      Date of manufacture<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={doseDetailsPg.date_of_manufacture}
                      className="customInput"
                      id="date_of_manufacture"
                      type="date"
                      name='date_of_manufacture'
                      max={maxDate}
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px",cursor: "not-allowed" }}
                      onChange={handleDoseDetails}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {doseDetailsPg.date_of_manufacture?null:
                    <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                    }
                  </div>
                  <div className="col">
                    <label htmlFor="expiry_date">
                      Expiry date<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={doseDetailsPg.expiry_date}
                      className="customInput"
                      id="expiry_date"
                      name='expiry_date'
                      type="date"
                      min={moment(today).format("YYYY-MM-DD")}
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" ,cursor: "not-allowed"}}
                      onChange={handleDoseDetails}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {doseDetailsPg.expiry_date?null:
                          <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                          }
                  </div>
                 
                  <div className="col">
                    <label htmlFor="batch_number">
                      Batch number<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={doseDetailsPg.batch_number}
                      className="customInput"
                      id="batch_number"
                      name='batch_number'
                      type="text"
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleDoseDetails}
                    />
                  </div>
                
                  </div>
                <div>
                  <div className="anyaetext">
                    <label htmlFor="">
                      Any adverse event within <b style={{color:"red"}}>{subjData?.immediate_adverse_event}</b>  min, post vaccination?
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                        id='Any adverse'
                          type="radio"
                          className="C-pointer"
                          value="yes"
                          checked={selectedOption === "yes"}
                          onChange={handleOptionChange}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Yes</span>
                      </label>

                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          className="C-pointer"
                          value="no"
                          checked={selectedOption === "no"}
                          onChange={handleOptionChange}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {regStep === 3 ? (
              selectedOption == "yes" ? (
                <div className="subject_reg_body">
                 

                
                  <div className="d-flex align-items-center">
                    <label htmlFor="lastName">
                      Is this a serious adverse criteria?
                    </label>
                    <span style={{ marginLeft: "20px" }}>
                      <ToggleButton
                        value={toggleSAE}
                        onToggle={handleSaeToggle}
                        inactiveLabel={"No"}
                        activeLabel={"Yes"}
                        colors={{
                          activeThumb: {
                            base: "rgb(250,250,250)",
                          },
                          active: {
                            base: "rgb(209, 65, 65)",
                          },
                          inactive: {
                            base: "rgb((0, 128, 0)",
                          },
                        }}
                      />
                    </span>
                  </div>
                  {toggleSAE ? (
                    <div className="text-start d-flex flex-column justify-content-between">
                     


                      <Row className='mt-0'>
                        <div className="d-block d-md-flex justify-content-between my-0 my-md-3 my-xxl-3 ">
                                  <Col><label htmlFor="search_block">Serious Adverse Criteria<span className="text-danger">*</span></label></Col>
                                  <Col>
                                    <div className="search_block" id='search_block' >
                                        <div className="orange_btn cutm_btn_pdng searchNselectmbl" onClick={handleDropDown} style={{width:"350px", padding:"12px 14px"}}
                                        > {btnTitle.length > 30 ? btnTitle.slice(0, 30) + "..." : btnTitle || 'Select Adverse Criteria'}
                                            <img src="./images/icons/selectarrow.svg" alt="" />
                                        </div>
                                        {showPopup && <div className="search_main" onBlur={() => {
                                            setTimeout(() => {
                                                if (showPopup) {
                                                    setShowPopup(false)
                                                }
                                            }, 200)
                                        }}>
                                            <div className='drop_down_for_search'>
                                                <input
                                                    type="text"
                                                    autoFocus
                                                    value={searchTerm}
                                                    onChange={handleSearch}
                                                    placeholder="Search..."
                                                />
                                                <img className='sasd' src="./images/icons/search.svg" alt="" />
                                                <div className="eventlist_items">
                                                    { saEvents &&
                                                                    saEvents.filter(i => {
                                                        const event = i.serious_adverse_event_name || '';
                                                        return event.toLowerCase().includes((searchTerm || '').toLowerCase())
                                                    }).map((data, index) => {
                                                    
                                                        return (
                                                            <ul className='aelistdropdown' key={index}>
                                                                <li className={`${data.serious_adverse_event_name === btnTitle ? 'selectedOption' : ''}`} onClick={() => handleOption(data)} >{data.serious_adverse_event_name|| 'Select Adverse Criteria'}</li>
                                                            </ul>
                                                        )
                                                    })}
                                                </div></div>
                                        </div>}
                                    </div>
                                  </Col>
                              </div>
                      </Row>
                    </div>
                  ) : null}
                  <Row className="text-start mt-0">
                  <div className="d-block d-md-flex justify-content-between my-0 my-md-3 my-xxl-3 ">

                    <Col className="align-self-center">
                      <label htmlFor="aeCalssification">
                        Adverse Event Classification<span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col className="subrej-custom-select-styl">
                      

                      <select 
                       id="aeCalssification"
                        className="orange_select"
                        value={aEClassification}
                        onChange={handleAEClassification}
                      >
                      <option >Select Adverse Event</option>
                      {studyTitles &&
                          studyTitles?.map((i) => {
                            
                            return(
                        <option key={i.study_aebank_id}
                        label={i.study_aebank_event_title}
                        value={i.study_aebank_id}
                        case_def={i.study_case_definition}>{i.study_aebank_event_title}</option>

                            )
                          })}
                      </select>
                    </Col>
                    </div>
                  </Row>
                  {aEClassification !== "" ? (
                    <div className="advEventGroup">
                      <div className="p-2 p-md-4 p-xxl-4 bg-light rounded eventClassificationDiv">
                        {caseDef === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? (
                            <div className="accordianClass">
                            <BrightonCase handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset}  getEventDescId={getEventDescId}/>
                            </div>
                          
                        ) : caseDef === EVENT_CLASSIFICATION_GRADE_CTCAE ? (
                          <Accordion >
                        <GradeCase handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset}  getEventDescId={getEventDescId}/>
                        </Accordion>
                        ) : caseDef === EVENT_CLASSIFICATION_AESI?
                        <Accordion >
                        <div className="fs-6" dangerouslySetInnerHTML={{ __html: studyAeDtls&& studyAeDtls[0]?.other_case?.study_aesi_description.replace(/(?:\r\n|\r|\n)/g, '<br>') }}></div> 
                        </Accordion>
                      
                        
                        :(
                          ""
                        )}
                      </div>

                       {caseDef === EVENT_CLASSIFICATION_AESI && 
                       
                        <div className={JustBtwn}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "start",
                          }}
                        >
                          <label htmlFor="input_notes">
                          Event Description<span className="text-danger">*</span>
                          </label>
                          <textarea
                            id="input_notes"
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              padding:"10px",
                              borderColor: "#E1E5E7",
                              borderRadius: "8px",
                            }}
                            value={inputTextNotes}
                            name={"other_input_notes"}
                            placeholder="type here"
                            onChange={handleAesiInputText}
                          />
                        </div>
                      </div>}

                        {caseDef === EVENT_CLASSIFICATION_OTHER && 
                        
                          <div className={JustBtwn}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "start",
                          }}
                        >
                          <label htmlFor="input_notes">
                          Event Description<span className="text-danger">*</span>
                          </label>
                          <textarea
                            id="input_notes"
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              padding:"10px",
                              borderColor: "#E1E5E7",
                              borderRadius: "8px",
                            }}
                            value={inputTextNotes}
                            name={"other_input_notes"}
                            placeholder="type here"
                            onChange={handleAesiInputText}
                          />
                        </div>
                      </div>
                      
                        
                        
                        }


                        <div className="d-flex justify-content-between mb-2">
                    <div className="mb-3">
                      <label htmlFor="date_of_onset" className="custm_label_fw">
                        Date of onset<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={fifthInputs.date_of_onset}
                        className="customInput custminputbml"
                        id="date_of_onset"
                        max={moment(today).format("YYYY-MM-DD")}
                        min={doseDetailsPg.date_of_administration}
                        name='date_of_onset'
                        type="date"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" ,cursor: "not-allowed"}}
                        onChange={handleAeOptions}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      {fifthInputs.date_of_onset?null:
                      <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                      }
                    </div>

                    <div className="">
                      <label htmlFor="time_of_onset" className="custm_label_fw">
                        Time of onset (24 Hrs)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={fifthInputs.time_of_onset}
                        className="customInput custminputbml"
                        name='time_of_onset'
                        id="time_of_onset"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                        onChange={handleAeOptions}
                      />
                      {fifthInputs.time_of_onset?null:
                      <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                      }
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="mb-3">
                      <label
                        htmlFor="dateOfResolution"
                        className="custm_label_fw"
                      >
                        Date of resolution
                         
                      </label>
                      <input
                        value={dateOfResolution}
                        className="customInput"
                        id="dateOfResolution"
                        max={moment(today).format('YYYY-MM-DD')}
                        min={fifthInputs.date_of_onset}
                        type="date"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px",cursor: "not-allowed" }}
                        onChange={handleDateOfResolutionChange}
                        onKeyDown={(e) => e.preventDefault()}
                        // disabled={fifthInputs.date_of_onset!==''&& fifthInputs.time_of_onset!==''?false:true}
                      />
                      {dateOfResolution?null:
                      <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                      }
                    </div>
                      {fifthInputs.date_of_onset === dateOfResolution ?
                        <div className="">
                      <label htmlFor="lastName" className="custm_label_fw">
                        Time of resolution (24 Hrs)
                        
                      </label>
                      <input
                        value={timeOfResolution}
                        className="customInput"
                        id="lastName"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                        onChange={handleTimeOfResolutionChange}
                        min={fifthInputs.time_of_onset}
                        onInput={validateTimeOfResolution}
                        />
                        {timeOfResolution?null:
                          <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                          }
                        <span style={{color:"red", fontSize:"14px"}}>
                          {showTimeError? timeError : null}
                        </span>
                    </div>
                    :
                    <div className="">
                      <label htmlFor="lastName" className="custm_label_fw">
                        Time of resolution (24 Hrs) {dateOfResolution && <span style={{ color: "red" }}>*</span> }
                        
                      </label>
                      <input
                        value={timeOfResolution}
                        className="customInput"
                        id="lastName"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                        onChange={handleTimeOfResolutionChange}
                      />
                      {timeOfResolution?null:
                          <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                          }
                    </div>

                      }
                    
                  </div>




                  <div className='coaadrpdnsdsk'>
                        <div className="">
                          <label htmlFor="causality">
                            Causality<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="causality"
                            value={fifthInputs.causality_id}
                            name='causality_id'
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {causalities &&
                              causalities.map((i) => {
                                return (
                                  <option
                                    key={i.causality_id}
                                    value={i.causality_id}
                                  >
                                    {i.causality_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        </div>
                        <div className="">
                          <label htmlFor="outCome">
                            Outcome <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="outCome"
                            className="selectTag"
                            name='outcome_id'
                            value={fifthInputs.outcome_id}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {outComes &&
                              outComes.map((i) => {
                                return (
                                  <option value={i.outcome_id} key={i.outcome_id}>
                                    {i.outcome_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                        </div>
                       

                      </div>

                      <div className='coaadrpdnsdsk'>
                      <div className="">
                          <label htmlFor="action_taken_for_ae">
                            Action Taken For Adverse Event <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="action_taken_for_ae"
                            className="selectTag"
                            name='action_taken_for_ae'
                            value={fifthInputs.action_taken_for_ae}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {actionTakenforAe &&
                              actionTakenforAe.map((i) => {
                                return (
                                  <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                    {i.action_taken_for_adverse_event_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                          {(newFlag!=="None" && !flag) && (
        <div className="start-end-date">
          <label htmlFor="startDate" className="custm_label_fw">
          Treatment Start Date {dateOfResolution&&<span className="text-danger">*</span>}
          </label>
          <input
            value={startDate}
            className="custminputbml "
            id="startDate"
            type="date"
            placeholder="Enter Start Date"
            aria-placeholder="#D4D4D4"
            style={{ padding: "16px 12px", width: "340px" }}
            onChange={handleStartDateChange}
            min={fifthInputs?.date_of_onset}
          />
        </div>
      )}
      </div>

                        <div className="">
                          <label htmlFor="actionTaken">
                            Action Taken For Study Vaccine<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="actionTaken"
                            name='action_taken_id'
                            value={fifthInputs.action_taken_id}
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {actnTakenOpts &&
                              actnTakenOpts.map((i) => {
                                return (
                                  <option
                                    key={i.action_taken_id}
                                    value={i.action_taken_id}
                                  >
                                    {i.action_taken_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        {/* End Date input */}
                        {(newFlag!=="None" && !flag) && (
        <div className="start-end-date">
          <label htmlFor="endDate" className="custm_label_fw">
          Treatment End Date {dateOfResolution&&<span className="text-danger">*</span>}
          </label>
          <input
            value={endDate}
            className="custminputbml"
            id="endDate"
            type="date"
            disabled={!startDate}
            placeholder="Enter End Date"
            aria-placeholder="#D4D4D4"
            style={{ padding: "16px 12px", width: "340px" }}
            onChange={handleEndDateChange}
            min={startDate}
          />
        </div>
      )}
                        </div>

                        </div>





{/* ////////////////////// */}
<div className="coaadrpdnsdmbl">
                          <label htmlFor="causality">
                            Causality<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="causality"
                            value={fifthInputs.causality_id}
                            name='causality_id'
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {causalities &&
                              causalities.map((i) => {
                                return (
                                  <option
                                    key={i.causality_id}
                                    value={i.causality_id}
                                  >
                                    {i.causality_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        </div>
                        <div className="coaadrpdnsdmbl">
                          <label htmlFor="outCome">
                            Outcome <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="outCome"
                            className="selectTag"
                            name='outcome_id'
                            value={fifthInputs.outcome_id}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {outComes &&
                              outComes.map((i) => {
                                return (
                                  <option value={i.outcome_id} key={i.outcome_id}>
                                    {i.outcome_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                        </div>

                        <div className="coaadrpdnsdmbl">
                          <label htmlFor="action_taken_for_ae">
                            Action Taken For Adverse Event <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="action_taken_for_ae"
                            className="selectTag"
                            name='action_taken_for_ae'
                            value={fifthInputs.action_taken_for_ae}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {actionTakenforAe &&
                              actionTakenforAe.map((i) => {
                                return (
                                  <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                    {i.action_taken_for_adverse_event_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                          {(newFlag!=="None" && !flag) && (
        <div className="start-end-date">
          <label htmlFor="startDate" className="custm_label_fw start-date">
          Treatment Start Date {dateOfResolution&&<span className="text-danger">*</span>}
          </label>
          <input
            value={startDate}
            className="custminputbml selectTag "
            id="startDate"
            type="date"
            placeholder="Enter Start Date"
            aria-placeholder="#D4D4D4"
            style={{ padding: "16px 12px", width: "340px" }}
            onChange={handleStartDateChange}
            min={fifthInputs?.date_of_onset}
          />
        </div>
      )}

      {/* End Date input */}
      {(newFlag!=="None" && !flag) && (
        <div className="start-end-date">
          <label htmlFor="endDate" className="custm_label_fw end-date">
          Treatment End Date {dateOfResolution&&<span className="text-danger">*</span>}
          </label>
          <input
            value={endDate}
            className="custminputbml selectTag"
            id="endDate"
            type="date"
            disabled={!startDate}
            placeholder="Enter End Date"
            aria-placeholder="#D4D4D4"
            style={{ padding: "16px 12px", width: "340px" }}
            onChange={handleEndDateChange}
            min={startDate}
          />
        </div>
      )}
      </div>

                        <div className="coaadrpdnsdmbl">
                          <label htmlFor="actionTaken">
                            Action Taken For Study Vaccine<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="actionTaken"
                            name='action_taken_id'
                            value={fifthInputs.action_taken_id}
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {actnTakenOpts &&
                              actnTakenOpts.map((i) => {
                                return (
                                  <option
                                    key={i.action_taken_id}
                                    value={i.action_taken_id}
                                  >
                                    {i.action_taken_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        </div>


                  {/* ////////////////////// */}






                      <div className={JustBtwn}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "start",
                          }}
                        >
                          <label htmlFor="treatment_given">
                            Any treatment given
                          </label>
                          <textarea
                            id="treatment_given"
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              padding:"10px",
                              borderColor: "#E1E5E7",
                              borderRadius: "8px",
                            }}
                            value={treatmentGiven}
                            placeholder="type here"
                            onChange={handleTreatment}
                          />
                        </div>
                      </div>
                      <div>
                        <span
                          style={{ display: "flex", alignContent: "start" }}
                        >
                          <label htmlFor="file-input-label">Attach files</label>
                        </span>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                          }}
                        >
                          <div
                            style={{ width: "500px", alignItems: "center" }}
                            className='subjreg_drop_zone'
                            id="drop-area"
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                          >
                            <div className="upload-icon" style={{}}>
                              <img
                                style={{
                                  height: "100px",
                                  margin: "6px",
                                  paddingLeft: "5px",
                                }}
                                src="./images/icons/Upload.svg"
                                alt=""
                              />
                              <h5 className='subjreg_drp_zone_txt'>Drag and drop files here </h5>
                              <h5 className='subjreg_drp_zone_txt'>or</h5>
                              <input
                                type="file"
                                id="file-input"
                                multiple
                                onChange={handleFileUpload}
                                disabled={fileNames.length >=3 ?true:false}
                                accept=".pdf, .ppt, .txt, .docx, .doc, .xls, .csv, .jpeg, .jpg, .png"
                              />
                              <label
                                htmlFor="file-input"
                                className=""
                              >
                                <span className="gray_btn px-4" style={{opacity:fileNames.length >=3 ? "50%":''}}>Browse Files</span>
                              </label>
                              <p  >(PDF, PPT, TXT, DOCX, DOC, XLS, CSV, JPEG, JPG, PNG)</p>
                            </div>
                            <div id="file-list" style={{ margin: "10px" }}>
                            {fileNames.map((fileName, index) => (
                                <div key={fileName} className="file-container">
                                  <div>{fileName}</div>
                                  {/* <button className="close-icon" onClick={() => handleRemoveFile(index)}>
                                    X
                                  </button> */}

                               <span className='close-icon' style={{ color: 'red'}} title='Click on this to delete the file' onClick={() => handleRemoveFile(index)}>✕</span>

                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="center_txt">
                  <h5 className='noaetxtmbl'>
                    As no adverse events were reported within {optedStudy?.immediate_adverse_event} minutes post
                    vaccination, <br />
                    you may continue.
                  </h5>
                </div>
              )
            ) : (
              ""
            )}
            {regStep === 4 && (
              <div className="subject_reg_body">
                <div>
                  <div className="">
                    <label htmlFor="mrName">
                      Concomitant medication administered at the same time, as
                      applicable
                    </label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px 0px",
                        }}
                      >
                        <input
                          type="radio"
                          value="yes"
                          checked={concomitantRadio === "yes"}
                          onChange={handleConcomitantRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Yes</span>
                      </label>

                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          value="no"
                          checked={concomitantRadio === "no"}
                          onChange={handleConcomitantRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>No</span>
                      </label>
                    </div>
                  </div>
                </div>
                {concomitantRadio === "yes" && (
                  <div className="concomitant_container">
                    <Row className="mt-0 ps-2 ps-md-0">
                      {medicationDetails.map((input, index) => (
                        <div
                          key={input.id}
                          className="position-relative concomitant_detials px-3 mt-4"
                        >
                          {index !== 0 && (
                            <button
                              onClick={() => handleDeleteFields(input, index)}
                              className="cross_btn"
                            >
                              <span>x</span>
                            </button>
                          )}

                    <div className='d-lg-flex  justify-content-between gap-5 '>
                          <InputComponent
                              type="text"
                              width={"320px"}
                              label={"Medication"}
                              required={'*'}
                              fontWeight={600}
                              placeholder={"Enter Medication Details"}
                              name="medication"
                              value={input.medication}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              width={"320px"}
                              fontWeight={600}
                              label={"Manufacturer"}
                              placeholder={"Enter Manufacturer Details"}
                              name="medication_manufacturer"
                              value={input.medication_manufacturer}
                              onChange={(e) => handleInputChange(index, e)}
                            />

                          </div>

                         <div className='d-lg-flex  justify-content-between gap-5 '>
                            <InputComponent
                            required={'*'}
                              type="text"
                              fontWeight={600}
                              width={"320px"}
                              placeholder={"Enter Batch Number"}
                              label={"Batch Number"}
                              name="medication_batch_number"
                              value={input.medication_batch_number}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              fontWeight={600}
                              width={"320px"}
                              label={"Route/Site"}
                              name="medication_route_site"
                              placeholder={"Enter Route/Site Details"}
                              value={input.medication_route_site}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </div>

                          <div className='d-lg-flex  justify-content-between gap-5 '>
                            <InputComponent
                            required={'*'}
                              type="text"
                              fontWeight={600}
                              width={"320px"}
                              placeholder={"Enter Dosage"}
                              label={"Dosage"}
                              name="medication_dosage"
                              value={input.medication_dosage}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              fontWeight={600}
                              width={"320px"}
                              label={"Frequency"}
                              name="medication_frequency"
                              placeholder={"Enter Frequency"}
                              value={input.medication_frequency}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </div> 
                        </div>
                      ))}
                    </Row>
                    {!medicationDtlsBtn && <div className="addBtn">
                      <button
                        className="white_btn px-4"
                        onClick={handleAddFields}
                      >
                        Add
                      </button>
                    </div>}
                  </div>
                )}
              </div>
            )}
            {regStep === 5 && (
              <div className="subject_reg_body">
               
                <div className= 'row d-flex justify-content-center justify-content-md-between gap-3 gap-md-5 gap-xxl-5 mt-2'>
                  {/* <div className="card viewCardStyl" >
                    <div className="card-header cardHeading">
                      <h6>Site Information</h6>
                    </div>
                    <div className="table-responsive body">
                      <table className='table card_columns_styl border-0'>
                        <tbody>
                          <tr>
                            <td>City</td>
                            <td>{piDetails?.city}</td>
                          </tr>
                          <tr>
                            <td>State</td>
                            <td>{piDetails?.state}</td>
                          </tr>
                          <tr>
                            <td>Mobile</td>
                            <td>{piDetails?.contact_number}</td>
                          </tr>
                          <tr>
                            <td>Subject ID</td>
                            <td>{subjNumber.sequence_number}</td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                  </div> */}


                  <div className="card viewCardStyl col-12 col-md-5 col-lg-5" >
                    <div className="card-header cardHeading">
                      <h6>Study Details</h6>
                    </div>
                    <div className=" cardBody">
                      <div className="table-responsive body">
                        <table className="table card_columns_styl border-0">
                          <tbody>
                            <tr>
                              <td>Study Name</td>
                              <td>{subjData?.study_name.length > 25 ? subjData?.study_name.slice(0, 25) + "..." : subjData?.study_name}</td>
                            </tr>
                            <tr>
                              <td>Route of administration</td>
                              <td>{subjData?.dose_administration_name}</td>
                            </tr>
                            <tr>
                              <td>Batch No.</td>
                              <td>{doseDetailsPg.batch_number}</td>
                            </tr>
                            <tr>
                            {/* {moment(subjData.current_dose.date_of_administration).format("DD-MM-YYYY")} */}
                              <td>Date of Administration</td>
                              <td>{moment(doseDetailsPg.date_of_administration ||today).format("DD-MM-YYYY")}</td>
                            </tr>
                            <tr>
                              <td>Expiry Date</td>
                              <td>{moment(doseDetailsPg.expiry_date).format("DD-MM-YYYY")}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="card step5_cards viewCardStyl">
                    <div className="card-header cardHeading">
                      <h6>Adverse Events</h6>
                    </div>
                    <div className=" cardBody table-responsive body">
                      <table className="table card_columns_styl border-0 ">
                        <tbody>
                          <tr>
                            <td>Date & Time of onset</td>
                            {/* <td>{moment(fifthInputs.date_of_onset).format('DD-MM-YYYY')} {fifthInputs.time_of_onset}</td> */}
                            <td>{fifthInputs.date_of_onset ? moment(fifthInputs.date_of_onset).format('DD-MM-YYYY') + " " + fifthInputs.time_of_onset : '-'}</td>

                          </tr>
                          <tr>
                            <td>Date & Time of Resolution</td>
                            <td>{dateOfResolution? moment(dateOfResolution).format('DD-MM-YYYY')+" "+timeOfResolution : '-'}</td>
                          </tr>
                          <tr>
                            <td>Adverse Event</td>
                            <td>{aeLabel===undefined?'-':aeLabel}</td>
                          </tr>
                          <tr>
                            <td>Serious Adverse Criteria</td>
                            <td>{seriousAE.label ? seriousAE.label :'-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>



                </div>



                <div className={JustBtwn}>
                  <div className="card viewCardStyl col-12 col-md-5 col-lg-5 w-100" >
                    <div className="card-header cardHeading ">
                      <h6>Concomitant Medication</h6>
                    </div>
                    <div className=" cardBody w-100">
                      {concomitantRadio === 'yes' ?
                        <div className=" body Concon_medication_main w-100">
                          <table className="table Concon_medication w-100 text-center">
                            <thead>
                              <tr>
                                <th scope="col">Medication</th>
                                <th scope="col">Batch Number</th>
                                <th scope="col">Manufacturer</th>
                                <th scope="col">Route/Site</th>
                                <th scope="col">Dosage</th>
                                <th scope="col">Frequency</th>
                              </tr>
                            </thead>
                            <tbody>
                              {medicationDetails?.map((i, index) => {
                                return (
                                  <tr key={index} className='text-center'>
                                    <td>{i.medication}</td>
                                    <td>{i.medication_batch_number}</td>
                                    <td>{i.medication_manufacturer}</td>
                                    <td>{i.medication_route_site}</td>
                                    <td>{i.medication_dosage}</td>
                                    <td>{i.medication_frequency}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        :
                        <div className="concomitantMsg">
                          <p>No Concomitant Medication</p>
                        </div>}
                    </div>
                  </div>

 

                </div>
              </div>
            )}

            <div className="registrationStepsFooter">
            {regStep === 1 && (
                <button
                  className="white_btn exit_white_btn_mbl"
                  onClick={handleExitSubRej}
                >
                  Exit
                </button>
              )}
              {regStep > 1 && (
                <button
                  className="white_btn white_btn_mbl"
                  onClick={() => handleStepChange(-1)}
                >
                  Previous
                </button>
              )}
              
           
              {regStep === 1 && (
                <div className='registrationStepsFooter'>
                <button className="white_btn exit_white_btn_mbl"
                onClick={handleClose}
                >Cancel</button>
                {validDuration ? 
                  <button
                    className={next}
                    onClick={() => handleStepChange(1)}
                    disabled={!subjectId }
                  >
                    Next
                  </button>:null}
                </div>
              )}
              {regStep === 2 && (
                <button
                  className={next}
                  onClick={() => handleStepChange(1)}
                  disabled={!( selectedOption!=='' && isDoseDetails)}
                >
                  Next
                </button>
              )}
              {regStep === 3 && (
                <button
                  className={next}
                  onClick={ () => handleStepChange(1) }
                  disabled={
  selectedOption==='no' ? false:
toggleSAE && seriousAE!=='' && aEClassification!=='' &&eventDesc!==undefined && inputTextNotes !=='' && fifthDisable && !dateOfResolution  ?false:
toggleSAE && seriousAE!=='' && aEClassification!=='' &&eventDesc!==undefined && inputTextNotes !=='' && fifthDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate  ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && fifthDisable && ! dateOfResolution ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && fifthDisable && ! dateOfResolution ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && fifthDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && fifthDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && fifthDisable && dateOfResolution && selectedAction ==='None' ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && fifthDisable && dateOfResolution && selectedAction ==='None' ?false:

toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && !dateOfResolution ?false:
toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && !dateOfResolution ?false:

toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:
toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && dateOfResolution && selectedAction ==='None' &&!startDate && !endDate ?false:

toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && dateOfResolution && selectedAction ==='None' && !startDate && !endDate ?false:
toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && dateOfResolution && selectedAction !=='None' && startDate && endDate ?false:

 
true 
                  }
                >
                  Next
                </button>
              )}

              {regStep === 4 && (
                <button
                  className={next}
                  onClick={() => handleStepChange(1)}
                  disabled={concomitantRadio==='yes' ? medicationDtlsBtn : false}
                >
                  Next
                </button>
              )}
              

              {regStep === 5 && (
                <button className="orange_btn orange_btn_mbl" disabled={isbtnDisabled} onClick={handleAddDosetoSubj}>
                  Submit
                </button>
              )}
            </div>
        </div>
        </div>
        </div>
        <PopUpModal
      handleClose={handleClosePopup}
      open={open}
      title={"Success!"}
      msg={"Dose added successfully!"}
      close={"Close"}
      actionbtn={"Done"}
      onConfirm={handleReviewActions}
  />
        </div>
       {loading && <Loader />}</>
        
    );
};

export default AddNewDoseToSubject;
